var map;

function initMap() {

  var tulsa = {
    info: '<strong>Bruce G. Weber</strong><br>\
					1700 Utica Square<br>Tulsa, OK 74114<br>\
					<a class="diamond-cellar" href="https://goo.gl/maps/tTLLdonHU3n">Get Directions</a>',
    lat: 36.1330136,
    lng: -95.9687845
    }


  var locations = [
    [tulsa.info, tulsa.lat, tulsa.lng, 0],
  ];

  var styles = {
    default: null,
    silver:
    [
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e9e9e9"
            },
            {
                "lightness": 17
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 17
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 29
            },
            {
                "weight": 0.2
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 18
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#dedede"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#ffffff"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "saturation": 36
            },
            {
                "color": "#333333"
            },
            {
                "lightness": 40
            }
        ]
    },
    {
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f2f2f2"
            },
            {
                "lightness": 19
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#fefefe"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#fefefe"
            },
            {
                "lightness": 17
            },
            {
                "weight": 1.2
            }
        ]
    }
]
  }

  var map = new google.maps.Map(document.getElementById('map'), {
		zoom: 14,
		center: new google.maps.LatLng(36.1330136, -95.9687845),
		mapTypeId: google.maps.MapTypeId.ROADMAP,
    mapTypeControl: false,
    fullscreenControl: false,
    streetViewControl: false
	});
  map.setOptions({styles: styles['silver']});

  var infowindow = new google.maps.InfoWindow({
  });

  var marker, i;
	for (i = 0; i < locations.length; i++) {
    var containsDiamond = locations[i].toString().indexOf("Diamond Cellar");
    var containsFive = locations[i].toString().indexOf("STORE 5a");
    if (containsDiamond > -1){
		  marker = new google.maps.Marker({
			  position: new google.maps.LatLng(locations[i][1], locations[i][2]),
			  map: map,
        icon: {
          url: "https://cdn.shopify.com/s/files/1/0037/0556/9378/files/rolex-icon.png?508",
          scaledSize: new google.maps.Size(25, 25)
        },
      });
    } else if (containsFive > -1){
      marker = new google.maps.Marker({
        position: new google.maps.LatLng(locations[i][1], locations[i][2]),
        map: map,
        icon: {
          url: "https://cdn.shopify.com/s/files/1/0037/0556/9378/files/rolex-icon.png?508",
          scaledSize: new google.maps.Size(25, 25)
        },
      });
    } else {
      marker = new google.maps.Marker({
        position: new google.maps.LatLng(locations[i][1], locations[i][2]),
        map: map,
        icon: {
          url: "https://cdn.shopify.com/s/files/1/0037/0556/9378/files/rolex-icon.png?508",
          scaledSize: new google.maps.Size(25, 25)
        },
      });
    }

		google.maps.event.addListener(marker, 'click', (function (marker, i) {
			return function () {
        if (locations[i][0].includes("Dublin")) {
          $(".info-drawer-columbus").hide();
          $(".info-drawer-dublin").show();
        } else {
          $(".info-drawer-dublin").hide();
          $(".info-drawer-columbus").show();
			  }
      }
		})(marker, i));
}
}
